"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.error.title': 'Activación fallida',
    'activate.error.generic': 'Ocurrió un error durante la activación de la cuenta',
    'activate.error.no_token': 'No se proporcionó token de activación',
    'activate.error.network': 'Ocurrió un error de red',
    'activate.error.invalid_link': 'Enlace de activación inválido',
    'activate.error.invalid_link_description': 'El enlace de activación que hiciste clic es inválido o ha expirado. Por favor intenta registrarte nuevamente o contacta soporte.',
};
